export const AUTH = 'AUTH' ; 
export const LOGOUT = 'LOGOUT' ; 
export const UPDATE_USER_COURSES_TAKEN = 'UPDATE_USER_COURSES_TAKEN'
export const UPDATE_COURSES_TAKEN = 'UPDATE_COURSES_TAKEN'
export const UPDATE_CONCEPTS_USED = 'UPDATE_CONCEPTS_USED'
export const UPDATE_NOTES_USED = 'UPDATE_NOTES_USED'
export const UPDATE_COMMENTS_USED = 'UPDATE_COMMENTS_USED'
export const UPDATE_EQUATIONS_USED = 'UPDATE_EQUATIONS_USED'
